import { useEffect, useState } from "react";
import HeaderComponent from "../Header/header.component";
import FooterComponent from "../Footer/footer.component";
import { Link } from "react-router-dom";

const NewProjectTemplate = ({
    templateData,
    templateEvent
}) => {
    const { 
      inventoryItems, 
      loading, 
      error, 
    } = templateData;
    const { 
        handleSearch,
        handleProduct
     } = templateEvent;

  return (
    <>
      {/* <HeaderComponent onClick={handleSearch} /> */}
      <main className="main">
        <section id="Productsec" className="Productsec section">
          <div className="container">
            <div className="ClsDescrip">
              <div className="Pimage">
                <div className="row">
                  <div
                    className="col-lg-4 LBlock d-flex flex-column"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div className="Productimage">
                      <img
                        src="assets/img/nxp-logo.png"
                        alt="NXP Icon"
                        className="clswatermark"
                      />
                      <br />
                      <img
                        src="assets/img/circuit-pin-page4.png"
                        alt="Product Icon"
                      />
                    </div>
                  </div>
                  <div
                    className="col-lg-8 RBlock"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="Productinfo">
                      <h2>Hybrid High-Density Supercapacitors – HSH Series</h2>
                      <h5>
                        Eaton HSH series ultra-high-capacitance energy storage
                        capacitors with a combination of advanced technologies
                        are ideal for power systems
                      </h5>
                      <p>
                        Eaton HSH series hybrid supercapacitors are
                        high-reliability, high-power, ultra-high-capacitance
                        energy storage devices utilizing proprietary materials
                        and processes. This combination of advanced technologies
                        allows Eaton to offer a wide variety of capacitor
                        solutions tailored to applications for backup power,
                        pulse power, and hybrid power systems. They can be used
                        as a sole energy storage device or in combination with
                        batteries to optimize cost, lifetime, and run time.
                        System requirements can range from a few microwatts to
                        hundreds of watts. These supercapacitors feature low ESR
                        for high power density with environmentally friendly
                        materials for a green power solution. Eaton
                        supercapacitors are maintenance-free, with design
                        lifetimes of up to 20 years and operating temperatures
                        down to -25°C and up to +70°C
                      </p>
                    </div>
                  </div>
                </div>

                <div className="ClsTabBlock row">
                  <div className="tabs-7">
                    <ul className="tabs">
                      <li>
                        <a href="#resource">Resources</a>
                      </li>
                      <li>
                        <a href="#features">Features</a>
                      </li>
                      <li>
                        <a href="#application">Application</a>
                      </li>
                    </ul>

                    <section className="tab_content_wrapper">
                      <article className="tab_content" id="resource">
                        <p>
                          Copyright eurus supplex undae fulgura congestaque
                          locis. Gravitate ante nabataeaque sua naturae satus
                          ad. <a href="#tab2">Copyright</a> madescit pugnabant
                          effervescere abscidit altae. Parte norant principio
                          vultus reparabat omni rapidisque.
                        </p>
                      </article>
                      <article className="tab_content" id="features">
                        <ul>
                          <li>
                            3.8 V operating voltage for high power and high
                            energy
                          </li>
                          <li>
                            Up to 10 times energy density compared to standard
                            supercapacitors{" "}
                          </li>
                          <li>Low ESR for high power density</li>
                          <li>UL recognized</li>
                          <li>
                            Low self-discharge is ideal for use with batteries{" "}
                          </li>
                          <li>
                            Warning - Do not overvoltage and do not reverse
                            polarity, or damage to the capacitor will occur
                          </li>
                        </ul>
                      </article>
                      <article className="tab_content" id="application">
                        <p>
                          Copyright flamma erectos tempora sorbentur illas foret
                          ambitae. Sata locavit triones. Terrarum tuti diversa
                          formas diffundi prima quod regio premuntur. Ipsa
                          pluviaque toto valles conversa quinta.
                        </p>
                      </article>
                    </section>
                  </div>
                </div>
              </div>
            </div>

            <div className="ClsTitle d-flex align-items-center">
              <div className="container position-relative">
                <div className="row">
                  <div className="title col-lg-9">
                    <h3>Hybrid High-Density Supercapacitors – HSH Series</h3>
                  </div>
                  <div className="filter col-lg-3">
                    <input type="text" value="Price Quality" />
                  </div>
                </div>
              </div>
            </div>

            <div className="ClsTable">
              <div className="PTabular">
                <div className="row">
                  <table>
                    <thead>
                      <tr className="titles">
                        <th></th>
                        <th>Image</th>
                        <th>Manufacturing Part Number</th>
                        <th>Description</th>
                        <th>Available Quantity</th>
                        <th>Price</th>
                        {/* <th>Quality</th> */}
                        <th>View Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Loading inventory items...
                          </td>
                        </tr>
                      ) : error ? (
                        <tr>
                          <td colSpan="8" className="text-center text-danger">
                            {error}
                          </td>
                        </tr>
                      ) : inventoryItems.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No inventory items found
                          </td>
                        </tr>
                      ) : (
                        inventoryItems?.map((item, index) => (
                          // console.log({item}),
                          <tr key={item.id || index}>
                            <td className="clspdf">
                              <img
                                src="assets/img/pdf-icon.png"
                                alt="PDF Icon"
                              />
                            </td>
                            <td className="clsimage">
                              <img
                                style={{ width: "70px", height: "70px" }}
                                src={item.image}
                                alt={item.part_number || "Product Icon"}
                              />
                            </td>
                            <td className="clsmanuf">
                              {item.part_number || "N/A"}
                            </td>
                            <td className="clsquan">
                              {item.description || "N/A"}
                            </td>
                            <td className="clsavail">
                              {item.available_qty || 0}
                            </td>
                            <td className="clsprice" style={{ width: "150px" }}>
                              {item.price && item.price.length > 0
                                ? item.price.map((priceItem, index) => (
                                    <div key={index} className="price-range">
                                      <div className="price-item">
                                        <span className="quantity">
                                          {priceItem.slab}
                                        </span>
                                        <span className="price">
                                          : ₹ {priceItem.price}
                                        </span>
                                      </div>
                                    </div>
                                  ))
                                : "0.00"}
                            </td>
                            <td className="clsview">
                              <Link
                                to={`/product/${item.part_number}`}
                                className="clsviewbtn"
                                onClick={() => handleProduct(item)}
                              >
                                View Details
                              </Link>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* <FooterComponent /> */}
    </>
  );
};

export default NewProjectTemplate;
